import React from 'react'
import SewingRepairHeader from './SewingRepairTable/SewingRepairHeader'
import SewingRepairRow from './SewingRepairTable/SewingRepairRow'

function SewingRepairTable(props) {
    const { listSewingRepair, loading, setType, setBrand, selectedBatchId, selectedAll, onResetSelected, onSelectAll, onUpdateSelectedBatches, reset } = props

    return (
        <div className='SewingRepairTable'>
            <table className='table table-borderless table-striped'>
                <SewingRepairHeader
                    selectedBatchId={selectedBatchId}
                    selectedAll={selectedAll}
                    onResetSelected={onResetSelected}
                    listSewingRepair={listSewingRepair}
                    onSelectAll={onSelectAll}
                    reset={reset}
                />
                <tbody className='SewingRepairRow'>
                    {
                        !!listSewingRepair && listSewingRepair.map((item, i) => {
                            return <SewingRepairRow
                                key={item._id}
                                index={i}
                                item={item}
                                setType={setType}
                                setBrand={setBrand}
                                selectedBatchId={selectedBatchId}
                                onUpdateSelectedBatches={onUpdateSelectedBatches}
                            />
                        })
                    }
                    {
                        !loading && listSewingRepair.length === 0 &&
                        <tr>
                            <td colSpan={9}>
                                No result
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    )
}

export default SewingRepairTable